namespace('compass.group');

compass.requireLib('compass.util.parse');
compass.requireLib('compass.util.format');

compass.group.EPSInfoWidget = compass.defineWidget(function EPSInfoWidget (options) {
	var me = this;
	var $j = jQuery;
	var d = jQuery.dom.getContext(this);

	var _settings = options;

	var RATE_LABEL = "avg nightly web rate";
	
	var _rangeFormatter = compass.util.dateFormatter('ddd, mmm d');
	var _numFormatter = _settings.meetingInfo.defaultDateFormatter;
	var _cf = _settings.meetingInfo.defaultCurrencyFormatter;
	var _formatNumber = compass.util.phoneFormatter({}) || {};

	var CONTACT_INFO = "We have partnered with a third party to fulfill your reservation. It can be cancelled online. Review your hotel policies for more information regarding hotel cancellations.<br/><br/>Any other changes cannot be made online. To make changes to your reservation, call to speak with an agent at %P between 8:00 AM and 4:30 PM Central Time USA, Monday - Friday. If you are outside the US, call our international number at +1 (312) 527-7300. Please note any changes made with an agent will not be reflected online.";
	if (!_settings.meetingInfo.affiliateHandledByOurAgent) {
		CONTACT_INFO = "We have partnered with a third party to fulfill your reservation. It can be cancelled online. Review your hotel policies for more information regarding hotel cancellations.<br/><br/>Any other changes cannot be made online. To make changes to your reservation, call to speak with an agent at (877) 502-7827. If you are outside the US, call our international number at +1 (417) 521-1279. Please have your Itinerary ID number ready. It can be found in your confirmation email. Please note any changes made with an agent will not be reflected online.";
	}
	
	var _defaultPhone = '(800) 355 8093';
	CONTACT_INFO = CONTACT_INFO.replace("%P", _settings.meetingInfo.phone ? _formatNumber(_settings.meetingInfo.phone) : _formatNumber(_defaultPhone));
	
	
	var RES_DATE = "";
	if (_settings.bookingDate.length > 0){
		var RES_DATE = "All information displayed here is as of " + _numFormatter(compass.util.parse.ISODateParser(_settings.bookingDate)) + ".";
	}

	
	
	me.render = function (widgetElem) {
		widgetElem.append(_makeHotelName());
		widgetElem.append(_makeRoomSummary());
		widgetElem.append(_makeRoomName());
		widgetElem.append(_makePoliciesLink());
		widgetElem.append(_makeReservationInfo());
		widgetElem.append(_makeCancelLink());
	};

	var _makeHotelName = function () {
		return d.div(
			d.div({ className: 'hotelName'}, _settings.hotelInfo.hotelName),
			d.div({ className: 'hotelRate'}, _cf(_settings.rate) + " | " + RATE_LABEL)
		);
	};

	var _makeRoomSummary = function () {
		var roomCount = _settings.roomCount.toString();
		roomCount += _settings.roomCount > 1 ? " rooms" : " room";

		var stayRange = _rangeFormatter(
			compass.util.parse.ISODateParser(_settings.checkIn)) + " - " + _rangeFormatter(compass.util.parse.ISODateParser(_settings.checkOut)
		);

		return d.div({ className: 'roomSummary' }, roomCount + " (" + stayRange + ")");
	};

	var _makeRoomName = function () {
		var bedRequest = _settings.is_bed_type_request ? "Bed Request:" : "";
		
		return d.div({className: 'roomNameSummary'},
					d.div({ className: 'roomName' }, _settings.room_name),
					d.span({ className: 'bedRequest' }, bedRequest),
					d.span({ className: 'bedType' }, _settings.bed_type)
		);
	};

	var _makeReservationInfo = function () {
		return d.div({ className: 'reservationInfo'},
					d.div({ }, CONTACT_INFO + (RES_DATE.length > 0 ? " " + RES_DATE : ""))
		);
	};
	
	var _makePoliciesLink = function () {
		var policiesDialogId = compass.generateId();

		return d.div({ className : 'policies' },
						d.a({className: 'policyLink', href: '#' }, 'View hotel policies &raquo;').activate(
							function _triggerPolicy() {
								me.trigger('EPSInfoWidget.policies', {dialogId: policiesDialogId});
								return false;
							})
		);
	};
	
	var _makeCancelLink = function () {
		var cancelRoomsDialogId = compass.generateId();

		return d.div({ className : 'cancelStay' },
						d.a({'aria-owns': cancelRoomsDialogId, href : '#' }, 'Cancel Rooms <abbr alt="">&raquo;</abbr>').activate(
							function _triggerCancel() {
								me.trigger('EPSInfoWidget.cancel', {dialogId: cancelRoomsDialogId});
								return false;
							})
		);
	};
}, {
	WUID: 'DEFAULT',
	widgetName: "EPSInfoWidget",
	meetingInfo : { }
});
